export var Subtopic;
(function (Subtopic) {
    Subtopic["EducationPlanning"] = "education-planning";
    Subtopic["FamilyAndEstate"] = "family-and-estate";
    Subtopic["HealthAndInsurance"] = "health-and-insurance";
    Subtopic["Investing"] = "investing";
    Subtopic["PersonalFinance"] = "personal-finance";
    Subtopic["Retirement"] = "retirement";
    Subtopic["Taxes"] = "taxes";
})(Subtopic || (Subtopic = {}));
